import Vue from 'vue'
import App from './App.vue'
import Storage from 'vue-ls'
import router from './router'
import $api from '@/api'
import store from './store'
import Vant, { Lazyload } from 'vant'
import Components from '@/components/index.js'

import '@/assets/css/normalize.css'
import 'vant/lib/index.css'

import config from '@/config'
import utils from '@/utils'

import '@/router/permission'
import hasPermission from '@/utils/hasPermission'
import {
  ACCESS_TOKEN,
  LANGUAGE
} from '@/store/variables'

import { VueAxios } from '@/utils/request'

Vue.config.productionTip = false
Vue.use(utils).use($api)
Vue.use(Storage, config.basic.storageOptions)
Vue.use(VueAxios, router)
Vue.use(Vant).use(Lazyload)
Vue.use(hasPermission)
Vue.use(Components)
new Vue({
  router,
  store,
  mounted () {
    store.commit('SET_TOKEN', Vue.ls.get(ACCESS_TOKEN))
    store.commit('TOGGLE_LANGUAGE', Vue.ls.get(LANGUAGE, config.basic.language))
  },
  render: h => h(App)

}).$mount('#app')
